<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  export let preview;
</script>

<div
  transition:fade={{ duration: 300 }}
  on:click={() => {
    preview = undefined;
  }}
  class="popup"
>
  <div on:click|stopPropagation class="popup-ctn">
    <img class="preview-img" src={preview} alt="" />
  </div>
</div>

<style>
  ::-webkit-scrollbar {
    height: 3.5px;
    width: 3px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
  }

  .popup {
    background: rgba(46, 41, 78, 0.84);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    z-index: 900;
    overflow-y: scroll;
  }

  .popup-ctn {
    position: relative;
    background: white;
    box-shadow: 0px 6px 58px rgba(121, 145, 173, 0.195504);
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    max-width: 95vw;
    max-height: 85vh;
    overflow: hidden;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .preview-img {
    width: 100%;
    height: 100%;
  }
</style>
